// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  if ( newUrl == url ) {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}

// Timber functions
window.timber = window.timber || {};//conflict with master slider link

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    // Product Page
    $productImageWrap: $('#ProductPhoto'),
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('.product-single__thumbnail'),
    $productImageCard: $('#ProductImage'),
    $variantImage: $('#VariantImage')
  }
};

timber.init = function () {
  // FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.productImageSwitch();
  timber.autoResponsiveElements();
  timber.productImageZoom();
};

timber.productPage = function (options) {
  // console.log(options);
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      vip_tag = options.vip_tag,
      translations = options.translations;
  // console.log(variant.inventory_quantity)
  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('form[id^="product_form"] .AddToCart:visible').not('.noClick'),
      $variantTitle = $('#variantTitle'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $variantImage = $('#VariantImage'),
      $variantPrice = $('#variantPrice'),
      $variantComparePrice = $('#variantComparePrice'),

      // $quantityElements = $('.quantity-selector, label + .js-qty'),
      $quantityElements = $('form[id^="product_form"] .product-single__quantity').find("input[name='quantity']"),
      
      $addToCartText = $addToCart.find('.AddToCartText');
  var addToCartDisabled = $addToCart.hasClass('disabled');

  if(vip_tag && $addToCart.next('.link_to_vip')){
    $addToCart.next('.link_to_vip').show();
  }

  /* i16系列 */
  if (location.href.includes('ultra-slim-case-for-iphone-16-series')) {
    if (options.variant) { 
        swatch_color_name = options.variant.option2.includes("Black/Grey") ? 'page1':'page2';
      }
    switch_show();
  }
 


  if (location.href.includes('magez-folio-2-for-ipad-pro')) {
    if (options.variant) {
        swatch_color_name = options.variant.option1.includes("iPad mini") ? 'ipadmini':'ipadpro';
      }
    switch_show();
  }
  
  if (location.href.includes('tactile-woven-case-for-iphone-16-series')) {
    if (options.variant) { 
        swatch_color_name = options.variant.option3.includes("Lumintex") ? 'page2':'page1';
      }
    switch_show();
  }

  if (location.href.includes('military-grade-protective-case-for-iphone-16-pro')) {
    if (options.variant) { 
        swatch_color_name = options.variant.option2.includes("Black/Grey") ? 'page1':'page2';
      }
    switch_show();
  }

  if (location.href.includes('pinbutton-phone-cases')) {
    swatch_color_name = "s25_black" //默认值
    if (options.variant) { 
        if ( options.variant.option1.includes('S25')) {
          if (options.variant.option2.includes('Gold')) {
            swatch_color_name = 's25_gold';
          }else{
            swatch_color_name = 's25_black';
          }
        }else{
          swatch_color_name = 's24';
        }
      }

      $('.content-variant').each(function(){
        console.log(222)
        const filter_name = $(this).attr('name');
        if(filter_name.includes(swatch_color_name)){
          $(this).removeClass('hidden');
        }else{
          $(this).addClass('hidden');
        }
      })
  }

  if (location.href.includes('magez-case-for-airpods-pro')
    ) {
      if (options.variant) {
        swatch_color_name = ((options.variant.option2.includes("Sunset")
        ) || (options.variant.option2.includes("Moonrise")) ||
          options.variant.option2.includes("Schwarz/grau")) ? 'page2' : 'page1';
      }
      if (options.variant?.option1 === 'AirPods Pro 3') {
        swatch_color_name = 'page3'
      }
      switch_show();
  }

  if (location.href.includes('ultra-slim-case-for-samsung-galaxy-z-fold7-flip7') 
  ) { 
    //特殊处理
     let swatch_type_name='';
      if (options.variant) {
        swatch_type_name = (options.variant.option2 == "Black/Grey") ? 'black-page':'sunset-page';
      }
      console.log("切换",swatch_type_name);
      
      $('.content-variant-type').each(function(){
        const filter_name = $(this).attr('name');
        if(filter_name == swatch_type_name){
          $(this).removeClass('hidden');
        }else{
          $(this).addClass('hidden');
        }
      })

       //修复图片宽度初始化未执行问题
       try {
        if (splitSlider_fold7flip7_sunset) {
          splitSlider_fold7flip7_sunset.setImgWidth()
        }
        if (splitSlider_fold7flip7_black) {
          splitSlider_fold7flip7_black.setImgWidth()
        }
      } catch (error) {
        
      }
  } 

    
  if(location.href.includes('military-grade-protective-case-for-iphone-16-pro')){
    $('.i16_tip').remove();
    if (options.variant && options.variant.id === 45147620507847) {
      const i16_tip = `<div class="i16_tip w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 mb-4">
          <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
           الطلب المسبق: سيبدأ شحن الطلبات المسبقة في 24 أكتوبر
          </p>
        </div>`;
      $('.product_content-prices').before(i16_tip);
      }
  }

  if (location.href.includes('glints-of-gold-phone-cases')) {
      $('.content-variant').each(function () {
        console.log("$(this).attr('name')",$(this).attr('name'));
        if($(this).attr('name').includes('glints')){
          $(this).removeClass('hidden').addClass('block');
        }else{
          $(this).addClass('hidden').removeClass('block');
        }
      })
      $('.glints_postage').remove();
        const glints_postage = `<div class="glints_postage w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 mb-4">
            <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
            شحن مجاني لجميع أغطية آيفون 17
            </p>
            <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
            وفّر 10٪ عند شراء 3 منتجات (أغطية وإكسسوارات iPhone 17).
            </p>
            <br>
            <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
            ✈️الطلب المسبق: سيتم بدء شحن الطلبات في أوائل نوفمبر.
            </p>
          </div>`;
      $('.product_content-prices').before(glints_postage);

      
  }

  if (location.href.includes('iphone-17-series') 
  ) { 
    let swatch_color = options.variant?.option2 ?? ''
    // let origin_swatch_caseType = options.variant?.option3 ?? ''
    let swatch_value =''
    let handle_value = location.href
    swatch_value= 'iphone-17'
    switch (true) {
      case swatch_color.includes('Black'):
      swatch_value += '+black' 
        break;
      case swatch_color.includes('OVER THE HORIZON'):
      swatch_value += '+over-the-horizon' 
        break;
      case swatch_color.includes('MILKY WAY GALAXY'):
      swatch_value += '+milky-way-galaxy' 
        break;
      case swatch_color.includes('Sunset'):
      swatch_value += '+sunset' 
        break;
      case swatch_color.includes('Moonrise'):
      swatch_value += '+moonrise' 
        break;
    }
    if (swatch_color.includes('PitaTap™')) {
            swatch_value += '+pitaTap'
          }else{
            swatch_value += '+normal'
     }
     switch (true) {
            case handle_value.includes('ultra-slim'):
            swatch_value +=  '+ultra-silm'
              break;
            case handle_value.includes('aramid-proguard'):
            swatch_value +=  '+pro-guard'
              break;
            case handle_value.includes('aramid-ultraguard'):
            swatch_value +=  '+ultra-guard'
              break;
          }
    console.log("i17组合值",swatch_value);


    //提升
       $('.i17_postage').remove();
      const i17_postage = `<div class="i17_postage w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 mb-4">
          <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
          شحن مجاني لجميع أغطية آيفون 17
          </p>
        </div>`;
      $('.product_content-prices').before(i17_postage);

      

     // i17的content-variant筛选不同
     $('.content-variant').each(function () {
        const filter_name_list = $(this).attr('name') ? $(this).attr('name').split('+') : [];
        const swatch_value_list = swatch_value.split('+');
        // 选中的值元素，包含name的每个元素
        if (isArraySubset(filter_name_list,swatch_value_list)) { 
          $(this).removeClass('hidden').addClass('block');
        } else {
          $(this).addClass('hidden').removeClass('block');
        }
        function isArraySubset(childArr, parentArr) {
          return childArr.every(e => parentArr.includes(e));
        }
      })
      


      // 动态五点的尺寸和重量
      if($('.specs-variant').length > 0){
          $('.specs-variant').each(function () {
            const specs_sku = $(this).attr('specs-sku');
            
            if (options.variant?.sku == specs_sku) {
              $(this).removeClass('hidden').addClass('block');
            } else {
              $(this).addClass('hidden').removeClass('block');
            }
          })
        }


      // i17粘滞文案问题
        $(document).ready(function() {
          $('.content-variant:not(.hidden)').find('.features-i17-container .sticky-container').each(function(){
              if ($(this).hasClass("active")) return
              $(this).addClass("active")
              const sticky_container_id = $(this).attr('id');
              const sticky_content_id = $(this).find('.sticky-content').attr('id');

            let s_ =  new hcSticky(`#${sticky_content_id}`, {
                stickTo: `#${sticky_container_id}`,
                innerTop: -132,
                bottomEnd: 0,
                responsive: {
                  1023: {
                    disable: true
                  }
                }
              });
            });
        });
  }
  if( product_handle == 'magsafe-woven-wallet'){
    const idList = [{id:45267976028359,text:'✈️الطلب المسبق: الشحن خلال ٨ إلى ١٠ نوفمبر'},{id:45267976061127,text:'✈️الطلب المسبق: الشحن خلال ٢١ - ٢٢ نوفمبر'}]
    const item=idList.find(item => item.id == variant?.id)
    $('.magnetisches_notice').remove();
      if (item) {
        addToCartText = 'JETZT VORBESTELLEN'
        const magnetisches_notice = `<div class="magnetisches_notice w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 my-6">
          ${item.text}
        </div>`;
      $('.preordernotice').append(magnetisches_notice);
    }
  } 
  if( product_handle == 'magez-case-for-airpods-pro'){
    const idList = [{id:45750461464775,text:'✈️الطلب المسبق: يبدأ الشحن في منتصف نوفمبر'}]
    const item=idList.find(item => item.id == variant?.id)
    $('.airpods_notice').remove();
      if (item) {
        addToCartText = 'JETZT VORBESTELLEN'
        const airpods_notice = `<div class="airpods_notice w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 my-6">
          ${item.text}
        </div>`;
      $('.preordernotice').append(airpods_notice);
    }
  } 
  if (location.href.includes('aramid-ultraguard-case-for-iphone-17-series')) {
      console.log('variant',variant?.id);
      const isNone = variant?.id === 45520295887047
      $('.aramid_postage').remove();
      // 在‘iphone-17-series’中重复出现了，需要移除
      $('.i17_postage').remove();

        const aramid_postage = `<div class="aramid_postage w-full border border-black border-opacity-20 bg-black bg-opacity-5 px-2 py-1.5 mb-4">
            <p class="text-size-12 sm:text-size-13 2xl:text-size-14">
            شحن مجاني لجميع أغطية آيفون 17
            </p>
            <p class="isNone-box text-size-12 sm:text-size-13 2xl:text-size-14 ">
            ✈️الطلب المسبق: سيتم بدء شحن الطلبات في أوائل نوفمبر.
            </p>
          </div>`;
      $('.product_content-prices').before(aramid_postage);
      if(!isNone){
        $('.isNone-box').hide();
      }
  }


  if (variant) {
    $variantTitle.text(variant.title);

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0], el_v = $variantImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
      Shopify.Image.switchImage(newImg, el_v, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // console.log(translations.add_to_cart)
      // Available, enable the submit button, change text, show quantity elements
      if($addToCartText.data("type")){
        const translations_type =  $addToCartText.data("type");
        $addToCartText.html(translations[translations_type]);
        $addToCartText.attr('text', translations[translations_type]);
        
        $addToCart.removeClass('disabled').prop('disabled', addToCartDisabled);
        // $quantityElements.show();
        $quantityElements.prop('disabled', addToCartDisabled);
      }else{
        $addToCartText.html(translations.add_to_cart);
        $addToCartText.attr('text', translations.add_to_cart);
        $addToCart.removeClass('disabled').prop('disabled', false);
      }
    } else {
      $addToCart.siblings('.link_to_vip').hide();
      // Sold out, disable the submit button, change text, hide quantity elements
      // console.log(translations.sold_out)
      $addToCartText.html(translations.sold_out);
      $addToCartText.attr('text', translations.sold_out);
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.attr('type', 'submit');
      // $quantityElements.hide();
      $quantityElements.prop('disabled', true);
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat));
    $variantPrice.html( Shopify.formatMoney(variant.price, moneyFormat));

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
      $variantComparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
      $variantComparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $addToCartText.attr('text', translations.unavailable);
    // $quantityElements.hide();
    $quantityElements.prop('disabled', true)
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('data-image');
      var newImage_s = $(this).attr('data-image-small');
      var newImageId = $(this).attr('data-image-id');
      timber.switchImage(newImage, { id: newImageId }, timber.cache.$productImage);
      // if(timber.cache.$productImageWrap.hasClass('hasDeco') && newImage.includes('-1')){
      //   timber.cache.$productImageWrap.find('.photo-deco').show();
      // }else{
      //   timber.cache.$productImageWrap.find('.photo-deco').hide();
      // }

      timber.switchImage(newImage_s, { id: newImageId }, timber.cache.$variantImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('data-src', src);
  $el.attr('data-image-id', imgObject.id);

  
};

timber.productPage_secondary = function (options) {
  //console.log(options);
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;
      //console.log(variant);
      // console.log(variant.inventory_quantity)
      // Selectors
  var item_id = "#" + selector.domIdPrefix;
  var $productImage = $(item_id).closest('form').find('.product-single__photos').find('img'),
      $addToCart = $(item_id).closest('form').find('.AddToCart:visible').not('.noClick'),
      $productPrice = $(item_id).closest('form').find('.product-single__price'),
      $productComparePrice = $(item_id).closest('form').find('.product-compare__price'),
      
      $addToCartText = $addToCart.find('.AddToCartText');
      
  // console.log($productImage);
  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage_secondary);
    }

    // Select a valid variant if available
    if (variant.available) {
      
      // console.log(translations.add_to_cart)
      // Available, enable the submit button, change text, show quantity elements

      if($addToCartText.data("type") && $addToCartText.data("type") == 'pre_order'){
        $addToCartText.html(translations.pre_order_now);
        $addToCartText.attr('text', translations.pre_order_now);
      }else{
        $addToCartText.html(translations.add_to_cart);
        $addToCartText.attr('text', translations.add_to_cart);
      }
      $addToCart.removeClass('disabled').prop('disabled', false);
      // $quantityElements.show();
    } else {
      
      // Sold out, disable the submit button, change text, hide quantity elements
      // console.log(translations.sold_out)
      $addToCartText.html(translations.sold_out);
      $addToCartText.attr('text', translations.sold_out);
      $addToCart.addClass('disabled').prop('disabled', true);
      
      // $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    var variantPrice = Shopify.formatMoney(variant.price, moneyFormat);
    $productPrice.html(variantPrice);
    $productPrice.attr('content', (variant.price / 100).toFixed(2));
    if ($productComparePrice) {
      $productComparePrice.hide();
      if (variant.compare_at_price > variant.price) {
        var variantComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
        $productComparePrice.show().html(variantComparePrice);
        $productComparePrice.attr('content', (variant.compare_at_price / 100).toFixed(2));
      }
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $addToCartText.attr('text', translations.unavailable);
    // $quantityElements.hide();

    var product = selector.product;
    //console.log(product);
    if (product.featured_image) {
      var newImg = product.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage_secondary);
    }
  }
};

timber.switchImage_secondary = function (src, imgObject, el) {
  // Make sure element is a jquery object
  //console.log(src)
  var $el = $(el);
  $el.attr('src', src);
  $el.attr('data-src', src);
  $el.attr('data-image-id', imgObject.id);
};

timber.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.productImageZoom = function () {
  
    return;
  

  if (!timber.cache.$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
    return;
  };

  // Destroy zoom (in case it was already set), then set it up again
  timber.cache.$productImageWrap.trigger('zoom.destroy');

  timber.cache.$productImageWrap.addClass('image-zoom').zoom({
    url: timber.cache.$productImage.attr('data-zoom')
  });

  if (!timber.cache.$productImageCard.length || timber.cache.$html.hasClass('supports-touch')) {
    return;
  };

  // Destroy zoom (in case it was already set), then set it up again
  timber.cache.$productImageCard.trigger('zoom.destroy');

  timber.cache.$productImageCard.addClass('image-zoom').zoom({
    url: timber.cache.$variantImage.attr('data-zoom')
  });
};


// Initialize Timber's JS on docready
$(timber.init)
